module.exports = __webpack_public_path__ + "54dde34b5fb76e492b4bf0fb9af202fd.webp";